export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Ian',
    'Feb',
    'Mar',
    'Apr',
    'Mai',
    'Iun',
    'Iul',
    'Aug',
    'Sep',
    'Oct',
    'Noi',
    'Dec',
  ],
  months: [
    'Ianuarie',
    'Februarie',
    'Martie',
    'Aprilie',
    'Mai',
    'Iunie',
    'Iulie',
    'August',
    'Septembrie',
    'Octombrie',
    'Noiembrie',
    'Decembrie',
  ],
  months_calendar: {
    January: 'Ianuarie',
    February: 'Februarie',
    March: 'Martie',
    April: 'Aprilie',
    May: 'Mai',
    June: 'Iunie',
    July: 'Iulie',
    August: 'August',
    September: 'Septembrie',
    October: 'Octombrie',
    November: 'Noiembrie',
    December: 'Decembrie',
  },
  // weekdays
  weekdays: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
  weekdays_booking_container: {
    Sunday: 'Duminică',
    Monday: 'Luni',
    Tuesday: 'Marți',
    Wednesday: 'Miercuri',
    Thursday: 'Joi',
    Friday: 'Vineri',
    Saturday: 'Sâmbătă',
  },
  weekdays_calendar: {
    Sun: 'Dum',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mie',
    Thu: 'Joi',
    Fri: 'Vin',
    Sat: 'Sâm',
  },
  // additional translations
  today: 'Azi',
  tomorrow: 'Mâine',
};
